import React from 'react';
import { InlineAlert } from '@xo-union/tk-component-alerts';

const ErrorToaster: React.FC<{ remove: () => void }> = ({ remove }) => {
  const removeRef = React.useRef(remove);
  removeRef.current = remove;

  React.useEffect(() => {
    const timeOut = setTimeout(() => removeRef.current(), 4500);
    return (): void => clearTimeout(timeOut);
  }, []);

  return <InlineAlert type="error">Something went wrong!</InlineAlert>;
};

export default ErrorToaster;
